import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref, watch, withDefaults } from 'vue'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageTextField',
  props: {
    content: { default: () => null },
    disabled: { type: Boolean, default: () => false }
  },
  emits: ['contentChange'],
  setup(__props: any, { emit }) {

const props = __props as { content: string|null, disabled:boolean };

const editor = ClassicEditor
const editorConfig = {
  toolbar: [
    'bold', 'italic', '|',
    'bulletedList', 'numberedList'
  ]
}

const editorData = ref<string|null>(null)



onMounted(() => {
  checkIfPropSet()
})

watch(() => props.content, () => {
  checkIfPropSet()
})

function checkIfPropSet () :void {
  if (props.content) {
    editorData.value = props.content
  } else {
    editorData.value = ''
  }
}

function textChanged (text:string) : void {
  emit('contentChange', text)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(CKEditor).component), {
    editor: _unref(editor),
    config: editorConfig,
    modelValue: editorData.value,
    disabled: props.disabled,
    onInput: textChanged
  }, null, 40, ["editor", "modelValue", "disabled"]))
}
}

})